// Links pointing to #book / #prescription open the form drawer on that form (see TheFormDrawer)
export default defineNuxtRouteMiddleware((to) => {
  const type = FORM_DRAWER_HASHES[to.hash]

  // The hash never reaches the server
  if (import.meta.server || !type)
    return

  useFormDrawer().value = type

  // Drop the hash: the same link can open the drawer again and there's no element to scroll to
  return navigateTo({ path: to.path, query: to.query, hash: '' }, { replace: true })
})
